<div *ngIf="selectedCustomerName === undefined">
    <button mat-button color="primary" (click)="openCustomerSearchDialog()">
        {{ buttonText | translate }}
    </button>
</div>
<mat-card appearance="outlined" *ngIf="selectedCustomerName !== undefined">
    <div class="selected-customer">
        <div class="customer-details">
            <div class="detail-number" *ngIf="selectedCustomerId">
                {{ selectedCustomerId }}
            </div>
            <div class="detail-name" *ngIf="selectedCustomerName">
                {{ selectedCustomerName }}
            </div>
        </div>
        <button mat-button color="primary" *ngIf="showClearButton" (click)="clearSelectedCustomer()">Ändern</button>
    </div>
</mat-card>
